import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.stata = bracketIndenting()
